import constants from '@/constants.js';
import { mapState } from 'vuex';
import { debounce } from '@/helpers';

export default {
    computed: {
        ...mapState('common', ['dialogs', 'panels']),
        elDialogs() {
            return new Proxy(this.dialogs, {
                set: (target, prop, value) => {
                    this.TOGGLE_DIALOG({ [prop]: value });

                    return true;
                }
            });
        },
        elPanels() {
            return new Proxy(this.panels, {
                set: (target, prop, value) => {
                    this.TOGGLE_PANEL({ [prop]: value });

                    return true;
                }
            });
        },
        searchInput: {
            get() {
                return this.searchValue;
            },
            set: debounce(function(val) {
                this.searchValue = val;
            }, 30)
        },
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
    }
}
